module.exports = __webpack_public_path__ + "img/jinggai.c4d92cb8.png";